import api from '../../utils/andromeda-api';

// Display label for a dues cycle record - shared by every surface that renders
// a cycle name (filter builder, Targeted Audience modal) so labels stay
// identical.
export const duesCycleLabel = cycle =>
  cycle.membershipName ? `${cycle.name} (${cycle.membershipName})` : cycle.name;

// Options are never scoped by cycle (NR-1464 spec section 3) - getDuesOptions
// takes only an org id, no duesCycleId.
export async function getDuesCycles(orgId) {
  try {
    const response = await api.get(`/dues/cycles/${orgId}`);
    return response.data.result;
  } catch (e) {
    console.error('Error retrieving dues cycles [getDuesCycles]', e);
    return { error: true };
  }
}

export async function getDuesOptions(orgId) {
  try {
    const response = await api.get(`/dues/options/${orgId}`);
    return response.data.result;
  } catch (e) {
    console.error('Error retrieving dues options [getDuesOptions]', e);
    return { error: true };
  }
}
